import { ReactNode } from 'react';
import {
  matchRoutes,
  Navigate,
  useLocation,
  type Location,
} from 'react-router-dom';
import { FeatureName } from 'models/feature-toggling.model';
import { useFeatureTogglesStore } from 'store/feature-toggling';
import { findFallbackSiblingPath } from 'hooks/helpers';
import routes from 'router';

interface LocationStateProps {
  visitedPaths?: string[];
}

interface FeatureGateProps {
  feature: FeatureName;
  children: ReactNode;
  routeMode?: boolean;
}

export const FeatureGate = ({
  feature,
  children,
  routeMode = false,
}: FeatureGateProps) => {
  const location: Location<LocationStateProps> = useLocation();
  const { isFeatureEnabled } = useFeatureTogglesStore();

  if (isFeatureEnabled(feature)) {
    return children;
  }

  if (!routeMode) {
    return null;
  }

  const matches = matchRoutes(routes, location.pathname);
  const visitedPaths = [
    ...(location.state?.visitedPaths ?? []),
    location.pathname,
  ];
  const fallbackPath = findFallbackSiblingPath(matches, visitedPaths);

  if (fallbackPath) {
    return (
      <Navigate replace state={{ visitedPaths }} to={`../${fallbackPath}`} />
    );
  }

  return <Navigate replace state={{ from: location }} to="/not-found" />;
};
